import { render, staticRenderFns } from "./NetaAttractionDetailsView.vue?vue&type=template&id=040ac6e7&scoped=true&"
import script from "./NetaAttractionDetailsView.vue?vue&type=script&lang=js&"
export * from "./NetaAttractionDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./NetaAttractionDetailsView.vue?vue&type=style&index=0&id=040ac6e7&lang=scss&scoped=true&"
import style1 from "./NetaAttractionDetailsView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040ac6e7",
  null
  
)

export default component.exports